import { Badge } from "react-bootstrap";


const BadgeEvento = ({ evento = null, name = null, size = null }) => {

    // console.log(estado_id)
    return (
        <>
            {name == "error" && <Badge bg="danger" className={`m-0 ${size == "lg" ? "fs-5" : "fs-6"}`}>ERROR</Badge>}
            {name == "user" && <Badge className={`m-0 ${size == "lg" ? "fs-5" : "fs-6"}`}>USER</Badge>}


            {evento == "updated" && <Badge bg="warning" className={`m-0 ${size == "lg" ? "fs-5" : "fs-6"}`} >UPDATED</Badge>}
            {evento == "error" && <Badge bg="danger" className={`m-0 ${size == "lg" ? "fs-5" : "fs-6"}`}>ERROR</Badge>}
        </>
    );
}
export default BadgeEvento
    ;